import {PaymentOptionType as PaymentOptionTypeCartV1} from '@wix/auto_sdk_ecom_current-cart';
import {PriceModel} from '../Price.model';

export class PaymentConfigModel {
  public savePaymentMethod: boolean;
  public depositAmount: PriceModel;
  public paymentOption: PaymentOptionType;

  constructor(params: PaymentConfigModel) {
    this.savePaymentMethod = params.savePaymentMethod;
    this.depositAmount = params.depositAmount;
    this.paymentOption = params.paymentOption;
  }

  public static fromCartV1({
    savePaymentMethod,
    depositAmount,
    paymentOption,
  }: {
    savePaymentMethod: boolean;
    depositAmount: PriceModel;
    paymentOption: PaymentOptionTypeCartV1;
  }): PaymentConfigModel {
    return new PaymentConfigModel({savePaymentMethod, depositAmount, paymentOption: paymentOptionMapV1[paymentOption]});
  }
}

export enum PaymentOptionType {
  DEPOSIT_ONLINE = 'DEPOSIT_ONLINE',
  FULL_PAYMENT_OFFLINE = 'FULL_PAYMENT_OFFLINE',
  FULL_PAYMENT_ONLINE = 'FULL_PAYMENT_ONLINE',
  MEMBERSHIP = 'MEMBERSHIP',
  MEMBERSHIP_OFFLINE = 'MEMBERSHIP_OFFLINE',
  MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER = 'MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER',
}

const paymentOptionMapV1: Record<PaymentOptionTypeCartV1, PaymentOptionType> = {
  [PaymentOptionTypeCartV1.DEPOSIT_ONLINE]: PaymentOptionType.DEPOSIT_ONLINE,
  [PaymentOptionTypeCartV1.MEMBERSHIP]: PaymentOptionType.MEMBERSHIP,
  [PaymentOptionTypeCartV1.MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER]:
    PaymentOptionType.MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER,
  [PaymentOptionTypeCartV1.MEMBERSHIP_OFFLINE]: PaymentOptionType.MEMBERSHIP_OFFLINE,
  [PaymentOptionTypeCartV1.FULL_PAYMENT_OFFLINE]: PaymentOptionType.FULL_PAYMENT_OFFLINE,
  [PaymentOptionTypeCartV1.FULL_PAYMENT_ONLINE]: PaymentOptionType.FULL_PAYMENT_ONLINE,
};
